// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__HkT_G","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2VA_0"};